import { Component, OnInit } from '@angular/core';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { ActivatedRoute } from '@angular/router';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { StepType, WorkflowStep } from 'app/models/workflow-step';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { finalize } from 'rxjs/operators';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-new-workflow-template',
  templateUrl: './new-workflow-template.component.html',
  styleUrls: ['./new-workflow-template.component.scss']
})
export class NewWorkflowTemplateComponent implements OnInit {

  constructor(private workflowTemplateService: WorkflowTemplateService,
    public workflowWizardService: WorkflowWizardService, public _route: ActivatedRoute, private ecoDocsTitleService: EcoDocsTitleService) {

  }

  ngOnInit() {
    
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard', false );

    if (this._route.snapshot.params.workflowid != 'new') {
      this.workflowWizardService.isLoading = true;
      this.workflowTemplateService.getOrCreateDraft(this._route.snapshot.params.workflowid).pipe(finalize(() => {
        this.workflowWizardService.isLoading = false;
      })).subscribe(res => {
        this.workflowWizardService.init(res);
      });      
    } else {
      this.workflowWizardService.init(this.workflowTemplateService.workflowTemplate());
    }
  }
}
